import React, { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import useAdminUserFetch from "./useAdminUserFetch";
import { PhoneInput } from "react-international-phone";
import toast from "react-hot-toast";

function CreateUser({ onHandleCancel }) {
  const [showPassword, setShowPassword] = useState(false);
  const { createUser, isCreatingUser } = useAdminUserFetch();
  const {
    register,
    handleSubmit,
    control,
    reset,
    setError,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: "",
      email: "",
      phoneNo: "",
      password: "",
      role: "0",
      address: "",
    },
  });
  const [success, setSuccess] = React.useState("");

  const onSubmit = (data) => {
    // setSuccess("");
    // setError();
    // console.log("data: ", data);
    if (!data.name || !data.email || !data.phoneNo || !data.password) {
      setError("form", {
        type: "manual",
        message: "Please fill in all required fields.",
      });
      toast.error("Please fill in all required fileds");
      return;
    }
    createUser(
      {
        ...data,
        role: Number(data.role),
      },
      {
        onSuccess: () => {
          setSuccess("User created successfully!");
          reset();
          onHandleCancel();
        },
        onError: (err) => {
          setError("form", {
            type: "manual",
            message: err?.response?.data?.error || "Failed to create user.",
          });
        },
      }
    );
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-6 w-full">
      <h2 className="text-xl font-semibold mb-2">Create New User</h2>
      {errors.form && (
        <div className="text-red-600 text-sm">{errors.form.message}</div>
      )}
      {success && <div className="text-green-600 text-sm">{success}</div>}
      <div>
        <label
          htmlFor="name"
          className="block text-sm font-medium text-gray-700 mb-2"
        >
          Name *
        </label>
        <input
          id="name"
          {...register("name", { required: true })}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          placeholder="Enter name"
        />
        {errors.name && (
          <span className="text-red-500 text-xs">Name is required</span>
        )}
      </div>
      <div>
        <label
          htmlFor="email"
          className="block text-sm font-medium text-gray-700 mb-2"
        >
          Email *
        </label>
        <input
          id="email"
          type="email"
          {...register("email", { required: true })}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          placeholder="Enter email"
        />
        {errors.email && (
          <span className="text-red-500 text-xs">Email is required</span>
        )}
      </div>
      <div>
        <label
          className="block text-sm font-medium text-gray-700 mb-2"
          htmlFor={"phoneNo"}
        >
          {"Phone Number *"}
        </label>
        <Controller
          id={"phoneNo"}
          name={"phoneNo"}
          control={control}
          rules={{ required: true }}
          render={({ field: { value, onChange } }) => (
            <PhoneInput
              value={value}
              onChange={(val, country) => {
                const dialCode = country?.country.dialCode || ""; // Get the dial code dynamically
                let cleanNumber = val.replace(/\D/g, ""); // Remove non-numeric characters

                // Case 1: If the number doesn't start with the dial code, add it
                if (!cleanNumber.startsWith(dialCode)) {
                  cleanNumber = `${dialCode}${cleanNumber}`;
                }

                // Case 2: If the number starts with the dial code and a leading 0, remove the 0
                if (cleanNumber.startsWith(`${dialCode}0`)) {
                  cleanNumber = `+${dialCode}${cleanNumber.slice(
                    dialCode?.length
                  )}`;
                }

                // Case 3: Handle numbers starting with the dialCode without a 0 in between
                if (cleanNumber.startsWith(dialCode)) {
                  cleanNumber = `+${cleanNumber}`; // Format as +20 or similar
                }

                // Finally, update the value with the correctly formatted number
                onChange(cleanNumber);
              }}
              placeholder="xxxx-xxxx xxxx"
              defaultCountry="eg"
              charAfterDialCode=""
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              inputClassName="w-full h-full "
              inputStyle={{
                background: "transparent",
                border: "none",
                color: "#000",
                fontSize: "1.5rem",
                height: "100%",
              }}
              countrySelectorStyleProps={{
                buttonStyle: {
                  background: "transparent",
                  border: "none",
                  borderRight: "2px solid #0000006a",
                  padding: "0 1rem",
                  color: "white",
                  width: "4rem",
                },
              }}
            />
          )}
        />
      </div>
      <div className="relative">
        <label
          htmlFor="password"
          className="block text-sm font-medium text-gray-700 mb-2"
        >
          Password *
        </label>
        <input
          id="password"
          type={showPassword ? "text" : "password"}
          {...register("password", { required: true })}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 pr-10"
          placeholder="Enter password"
        />
        <button
          type="button"
          tabIndex={-1}
          onClick={() => setShowPassword((prev) => !prev)}
          className="h-full absolute top-2/3 right-3 -translate-y-1/2 text-gray-500 hover:text-gray-700 focus:outline-none"
        >
          {showPassword ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
            >
              <path
                fill="#808080"
                d="M2 5.27L3.28 4L20 20.72L18.73 22l-3.08-3.08c-1.15.38-2.37.58-3.65.58c-5 0-9.27-3.11-11-7.5c.69-1.76 1.79-3.31 3.19-4.54zM12 9a3 3 0 0 1 3 3a3 3 0 0 1-.17 1L11 9.17A3 3 0 0 1 12 9m0-4.5c5 0 9.27 3.11 11 7.5a11.8 11.8 0 0 1-4 5.19l-1.42-1.43A9.86 9.86 0 0 0 20.82 12A9.82 9.82 0 0 0 12 6.5c-1.09 0-2.16.18-3.16.5L7.3 5.47c1.44-.62 3.03-.97 4.7-.97M3.18 12A9.82 9.82 0 0 0 12 17.5c.69 0 1.37-.07 2-.21L11.72 15A3.064 3.064 0 0 1 9 12.28L5.6 8.87c-.99.85-1.82 1.91-2.42 3.13"
                strokeWidth={0.5}
                stroke="#808080"
              ></path>
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
            >
              <path
                fill="#808080"
                d="M21.87 11.5c-.64-1.11-4.16-6.68-10.14-6.5c-5.53.14-8.73 5-9.6 6.5a1 1 0 0 0 0 1c.63 1.09 4 6.5 9.89 6.5h.25c5.53-.14 8.74-5 9.6-6.5a1 1 0 0 0 0-1M12.22 17c-4.31.1-7.12-3.59-8-5c1-1.61 3.61-4.9 7.61-5c4.29-.11 7.11 3.59 8 5c-1.03 1.61-3.61 4.9-7.61 5"
                strokeWidth={0.5}
                stroke="#808080"
              ></path>
              <path
                fill="#808080"
                d="M12 8.5a3.5 3.5 0 1 0 3.5 3.5A3.5 3.5 0 0 0 12 8.5m0 5a1.5 1.5 0 1 1 1.5-1.5a1.5 1.5 0 0 1-1.5 1.5"
                strokeWidth={0.5}
                stroke="#808080"
              ></path>
            </svg>
          )}
        </button>
        {errors.password && (
          <span className="text-red-500 text-xs">Password is required</span>
        )}
      </div>
      <div>
        <label
          htmlFor="role"
          className="block text-sm font-medium text-gray-700 mb-2"
        >
          Role
        </label>
        <select
          id="role"
          {...register("role")}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        >
          <option value="0">User</option>
          <option value="1">Admin</option>
        </select>
      </div>
      {/* <div>
        <label
          htmlFor="address"
          className="block text-sm font-medium text-gray-700 mb-2"
        >
          Address
        </label>
        <input
          id="address"
          {...register("address")}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          placeholder="Enter address"
        />
      </div> */}
      <div className="flex space-x-4">
        <button
          type="submit"
          disabled={isCreatingUser}
          className="bg-blue-600 text-white px-6 py-2 rounded-md hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isCreatingUser ? "Creating..." : "Create User"}
        </button>
        <button
          type="button"
          onClick={onHandleCancel}
          className="bg-gray-300 text-gray-700 px-6 py-2 rounded-md hover:bg-gray-400 transition-colors"
        >
          Cancel
        </button>
      </div>
    </form>
  );
}

export default CreateUser;
